import { useTranslation } from 'react-i18next';
import { useConfirmDialog } from 'contexts/ConfirmDialog';
import { useAddresses } from 'contexts/Addresses';
import { ADDRESSES_LIMIT, CONFIRM_DIALOG_DEFAULT_VALUE } from 'appConstants';

export default function useFieldCustomers(transNamespace) {
  const confirmDialog = useConfirmDialog();
  const { t } = useTranslation(transNamespace);
  const {
    actions: { loadAddresses },
  } = useAddresses();

  const cmpNewValueToOld = (newVal, oldVal) => {
    if (!newVal) return false;
    return newVal.customerNumber === oldVal.customerNumber;
  };

  const accountChangeDialog = async (products, value) => {
    const { confirmed } =
      products && products.length && value.customerReference
        ? await confirmDialog({
            title: t('dialogs.accountChange.title'),
            message: t('dialogs.accountChange.description'),
            onActionLabel: t('dialogs.accountChange.buttonPrimary'),
          })
        : CONFIRM_DIALOG_DEFAULT_VALUE;

    return confirmed;
  };

  const loadAddressesFromOption = (option) => {
    if (option && option.customerReference) {
      const { customerReference } = option;

      loadAddresses({ limit: ADDRESSES_LIMIT, customer: customerReference });
    }
  };

  return {
    cmpNewValueToOld,
    accountChangeDialog,
    loadAddressesFromOption,
  };
}
